// removed by extract-text-webpack-plugin
module.exports = {"icon":"icon__icon___2Oo5e"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Icon/icon.css
// module id = 292
// module chunks = 1